export default "__VITE_ASSET__CpQuXLta__"